import React, { FC, useMemo } from 'react';

import { debounce } from '@mui/material';
import { Box } from '@mui/system';
import { useFormik } from 'formik';

import CustomTextField from '../../../../../common/CustomTextField';
import strings from '../../../../../../localization';
import styles from '../../styles';
import { useComponentDidUpdate } from '../../../../../../hooks/useComponentDidUpdate';

interface IAssignAccountsSearch {
  setSearch: (value: string) => void;
}

const SEARCH_DEBOUNCE_MS = 300;

/**
 * Every pharmacy is already in the store, so this only narrows what the left
 * list renders -- the debounce keeps typing smooth on long lists.
 */
const AssignAccountsSearch: FC<IAssignAccountsSearch> = ({ setSearch }) => {
  const formik = useFormik({
    initialValues: {
      search: '',
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onSubmit: () => {},
  });

  const { search } = formik.values;

  const debouncedSearch = useMemo(
    () =>
      debounce((input: string) => {
        setSearch(input);
      }, SEARCH_DEBOUNCE_MS),
    [setSearch],
  );

  useComponentDidUpdate(() => {
    debouncedSearch(search);
  }, [debouncedSearch, search]);

  return (
    <Box sx={styles.searchContainer}>
      <CustomTextField
        name="search"
        customClass={styles.borderRadiusRemove}
        formik={formik}
        id="search"
        errorContainer={false}
        placeholder={strings.search}
      />
    </Box>
  );
};

export default AssignAccountsSearch;
